const setCheckboxRequestCostCodeDisabled = boolValue => {
	const checkbox = document.querySelector('#request-cost-code');

	if (checkbox) {
		checkbox.disabled = boolValue;
	}
};

export const addEventListenerCheckboxPatronConfirmation = () => {
	const checkbox = document.querySelector('#patron-confirmation');
	const passwordInput = document.querySelector('#cod-password');

	if (checkbox && !passwordInput) {
		checkbox.addEventListener('change', event => {
			if (checkbox.checked) {
				setCheckboxRequestCostCodeDisabled(false);
			} else {
				setCheckboxRequestCostCodeDisabled(true);
			}
		});
	}
};

/**
 * This was built to hide server-side errors when the user interacts with (blurs) the input field. 
 * Otherwise these type of errors stay even on reloads.
 * TODO: This can be well improved, due tue lack of time just basically implemented.
 * @param {string} inputElement
 * @param {string} errorElementToHide
 * @param {string} [optSecondErrorElementToHide]
 */
export const hideErrorMessageOnBlur = (inputElement, errorElementToHide, optSecondErrorElementToHide) => {
	if (!(inputElement && errorElementToHide)) {
		return;
	}

	const inputElementFound = document.querySelector(inputElement);
	const errorElementToHideFound = document.querySelector(errorElementToHide);

	if (!(inputElementFound && errorElementToHideFound)) {
		return;
	}
	
	inputElementFound.addEventListener('blur', event => {
		if (optSecondErrorElementToHide) {
			const secondErrorElementToHideFound = document.querySelector(optSecondErrorElementToHide);
			
			if (secondErrorElementToHideFound) {
				errorElementToHideFound.remove();
				secondErrorElementToHideFound.remove();

				return;
			}
		}
		
		return errorElementToHideFound.remove();
	});
};
